import $ from "jquery"
window.$ = window.jQuery = $
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import ManagerApp from '@/components/ManagerApp'
import {createPinia} from "pinia";
import "bootstrap"
import "admin-lte"
import "admin-lte/plugins/fontawesome-free/css/all.min.css"
import "admin-lte/dist/css/adminlte.min.css"


const routes = [
    { path: "/login", name: "Login", component: () => import("@/components/LoginPage") },
    { path: "/", name: "Tenants", component: () => import("@/components/TenantsPage") },
    { path: "/tenant/:id", name: "Tenant", component: () => import("@/components/TenantPage") },
    { path: "/progibox/", name: "ProgiboxList", component: () => import("@/components/ProgiboxListPage") },
    { path: "/progibox/:id", name: "Progibox", component: () => import("@/components/ProgiboxPage") },
    { path: "/realms", name: "Realms", component: () => import("@/components/RealmsPage") },
    { path: "/realm/:id", name: "Realm", component: () => import("@/components/RealmPage") },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const pinia = createPinia()
const vue_app = createApp(ManagerApp)

vue_app.use(pinia)
vue_app.use(router)
vue_app.mount('#app')
